import * as React from 'react'

import * as coffee from './collections/Coffee'
import * as colored from './collections/Colored'
import * as crowdfunding from './collections/Crowdfunding'
import * as currencies from './collections/Currencies'
import * as decoration from './collections/Decoration'
import * as fill from './collections/Fill'
import * as paymentMethods from './collections/PaymentMethods'
import * as stroke from './stroke'
import * as thirdParty from './thirdParty'
import * as twoToned from './collections/TwoToned'

import { SpecificIconProps } from './types'

import { SvgSpritesheet } from './SvgSpritesheet'

export type IconElement = (props: SpecificIconProps) => React.ReactElement<SpecificIconProps>

export * from './Currency'
export * from './Icon'
export * from '../InlineSvg'
export * from '../SizedSvg'

export {
  coffee,
  colored,
  crowdfunding,
  currencies,
  decoration,
  fill,
  paymentMethods,
  stroke,
  thirdParty,
  twoToned,
  SvgSpritesheet,
}
